export default __webpack_public_path__ + "static/media/DAI.1096719c.svg";